<template>
  <v-flex >
    <v-toolbar flat class=" text-xs-center">
      <v-toolbar-title class="">{{msg}}</v-toolbar-title>
    </v-toolbar>
   
    <v-card flat tile class="mb-4 ">
      <v-container  fluid grid-list-lg >
        <v-layout >
          <v-flex justify-center text-xs-left>
            <v-card-text>
                <a href="help#self-assess" flat round  block color="primary" dark class="text-xs-center" title="Learn How to Self-Assess Your Voice Function"  >Learn How to Self-Assess Your Voice Function</a>      
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-flex>
</template>
<script>
export default {
	data () {
		return {
			msg: 'Daily Assessment',
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/home/SelfAssess.vue